import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SequencesService {


  url = environment.serverAPI10 + "/api/sequences";

  url1 = environment.serverAPI10 + "/api/sequenceSteps";

  url2 = environment.serverAPI10 + "/api/sequenceMailTemplates";

  url3 = environment.serverAPI10 + "/api/createTask"

  url4 = environment.serverAPI10 + "/api/emailsendreport";


  ur5 = environment.serverAPI10 + "/api/sequenceSteps";


  ur6 = environment.serverAPI10 + "/api/leadConnectionCount";

  ur7 = environment.serverAPI10 + "/api/sequenceAnalytics";

  ur8 = environment.serverAPI10 + "/api/leadTaskCount";

  ur9 = environment.serverAPI10 + "/api/sequenceStepCounts";

  ur10 = environment.serverAPI10 + "/api/sequencesLeadCallTask";

  ur11 = environment.serverAPI10 + "/api/sequencesLeadCallStatus";

  ur13 = environment.serverAPI10 + "/api/sequenceEmail-metrics/condition/step";

  ur14 = environment.serverAPI10 + "/api/status-count";

  ur12 = environment.serverAPI10 + "/api/sequence";

  url14 = environment.serverAPI10 + "/api/sequenceStepWhatsappStats/condition/step/count";


  ur15 = environment.serverAPI10 + "/api/sequences/solar";


  constructor(private http: HttpClient,
  ) { }

  getSequences(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }


  getSequencesSolarAll(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.ur15}/filter?search=&page=${Page}&size=${size}&sort=${sort}`);
  }

  getSequencesById(sequenceId: number): Observable<Object> {
    return this.http.get(`${this.url}/${sequenceId}`);
  }

  addOrEditSequences(Sequences: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, Sequences);
  }

  sequenceAlreadyExist(payload: any): Observable<any> {
    return this.http.post(`${this.url}/check/exist`, payload);
  }

  SequencesSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllSequencesDropDown() {
    return this.http.get(`${this.url}/dropdown`);
  }

  getAllSequencesSteps(sequenceId: number) {
    return this.http.get(`${this.url1}/steps/${sequenceId}`);
  }

  createSequencesStep(Sequences: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}`, Sequences);
  }

  createSequencesMailTemplates(Sequences: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url2}`, Sequences);
  }

  deleteBySequenceStepId(id: any): Observable<Object> {
    return this.http.delete(`${this.url1}/${id}`);
  }

  updateLeadSequnces(sequenceId: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}`, sequenceId);
  }
  searchEmailsendreport(query: string, type: string, sequenceId: number, stepId: number): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
    };

    return this.http.post<Response[]>(`${this.url4}/condition/${type}?sequenceId=${sequenceId}&stepId=${stepId}`, requestBody);
  }


  getSequencesMaxIntervalById(sequenceStepId: number): Observable<Object> {
    return this.http.get(`${this.ur5}/max-interval/${sequenceStepId}`);
  }

  getSequencesActiveCountById(sequenceStepId: number): Observable<Object> {
    return this.http.get(`${this.ur5}/active-count/${sequenceStepId}`);
  }

  getAllCompletedTaskCount(actionTypeId: any, sequenceId: any, stepId: any, completed: any): Observable<Object> {
    return this.http.get(`${this.url3}/completedCount?actionTypeId=${actionTypeId}&sequenceId=${sequenceId}&stepId=${stepId}&completed=${completed}`);
  }


  getAllCreateTaskCount(sequenceId: any, currentTask: any, completed: any): Observable<Object> {
    return this.http.get(`${this.url3}/createTaskCount?sequenceId=${sequenceId}&currentTask=${currentTask}&completed=${completed}`);
  }

  getAllGetAllSequences(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition/${queryParams}`, requestBody);
  }

  getAllLeadConnectionCounts(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur6}/condition/${queryParams}`, requestBody);
  }


  getAllSequenceAnalytics(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur7}/condition/${queryParams}`, requestBody);
  }

  getAllLeadTaskCounts(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur8}/condition/${queryParams}`, requestBody);
  }

  getAllSequenceStepCounts(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur9}/condition/${queryParams}`, requestBody);
  }

  getAllSequencesLeadCallTask(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur10}/condition/${queryParams}`, requestBody);
  }

  getAllSequencesLeadCallStatus(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur11}/condition/${queryParams}`, requestBody);
  }

  getAllSequencesEmailCount(query: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };

    return this.http.post<Response[]>(`${this.ur13}`, requestBody);
  }

  getAllSequencesByLeadIdNew(Page: any, size: any, sort: any, leadId: any): Observable<Object> {
    return this.http.get(`${this.url3}/linked/${leadId}?page=${Page}&size=${size}&sort=${sort}`);
  }

  updateLeadSequncesBulk(leadObject: any, sequenceId: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url3}/bulk/${sequenceId}`, leadObject);
  }

  getTaskById(taskId: string): Observable<any> {
    return this.http.get(`${this.url3}/${taskId}`);
  }

  cloneSequence(sequenceId: number): Observable<any> {
    return this.http.post(`${this.url}/clone/${sequenceId}`, {});
  }

  sequenceVarientStatus(id: any): Observable<any> {
    return this.http.post(`${this.url}/update/varientStatus/${id}`, {});
  }

  getStatusCount(sequenceId: number): Observable<any> {
    return this.http.get(`${this.ur14}?sequenceId=${sequenceId}`);
  }

  getStatusCountWithStep(sequenceId: number, stepId: number): Observable<any> {
    return this.http.get(`${this.ur14}/by-step?sequenceId=${sequenceId}&stepId=${stepId}`);
  }
  deleteLeadsFromSequence(leadIds: number[], sequenceId: string): Observable<any> {
    return this.http.post(`${this.ur12}/lead/multiple/${sequenceId}`, leadIds);
  }

  deleteAllSequenceId(sequenceId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${sequenceId}`);
  }



  getStatusCountWithStepNew(query: string, groupBy: any, additionalQuery: string): Observable<Response[]> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };

    return this.http.post<Response[]>(`${this.url14}`, requestBody);
  }


  getSequencesBySearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.ur15}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

}


